export default __webpack_public_path__ + "static/media/logo4.c25ebc47.jpg";